/* eslint-disable react/jsx-no-useless-fragment */
import { CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

export function LineChart(props) {
  const { data, selectedYear, title } = props;

  const [loading, setLoading] = useState(true);

  const options = {
    chart: {
      type: 'line',
      toolbar: {
        show: false,
      },
      stroke: {
        curve: 'smooth',
      },
    },
    tooltip: {
      enabled: true,
    },
    yaxis: {
      labels: {
        formatter(value) {
          return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(value);
        },
      },
    },
    xaxis: {
      categories:
        data.length &&
        data[selectedYear].monthly_data.map((month) => month.month),
    },
    title: {
      text: title,
      margin: 16,
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
        fontFamily: 'Montserrat, Arial, sans-serif',
        color: '#434242',
      },
    },
  };

  const series = [
    {
      name: `${title} do mês`,
      data:
        data.length &&
        data[selectedYear].monthly_data.map((acc) => acc.accumulated),
    },
  ];

  useEffect(() => {
    if (data.length) {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [data]);

  return (
    <>
      {!loading ? (
        <Chart type="line" options={options} series={series} height={240} />
      ) : (
        <div style={{ marginLeft: 19 }}>
          <CircularProgress />
        </div>
      )}
    </>
  );
}

LineChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      monthly_data: PropTypes.arrayOf(
        PropTypes.shape({
          accumulated: PropTypes.string,
          month: PropTypes.string,
          total: PropTypes.string,
        })
      ),
      year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  selectedYear: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
};
